import { render, staticRenderFns } from "./BfMarkdown.vue?vue&type=template&id=b89daf44&"
import script from "./BfMarkdown.vue?vue&type=script&lang=js&"
export * from "./BfMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./BfMarkdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports